"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/button/examples/index.ts';
var ButtonExample = /** @class */ (function () {
    function ButtonExample() {
        this.align = 'center';
        this.compact = false;
        this.active = false;
        this.disabled = false;
        this.loading = false;
        this.iconLeft = true;
        this.iconRight = false;
        this.label = true;
        this.rounded = false;
        this.basic = false;
        this.outlined = false;
        this.fluid = false;
        this.sublabel = false;
    }
    ButtonExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), direction: 'column', src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Button, {
                align: this.align,
                active: this.active,
                basic: this.basic,
                compact: this.compact,
                disabled: this.disabled,
                label: this.label && 'Button',
                sublabel: this.sublabel && 'Sublabel: ',
                loading: this.loading,
                fluid: this.fluid,
                iconLeft: this.iconLeft ? _1.Icons.SETTINGS : undefined,
                iconRight: this.iconRight ? _1.Icons.CHEVRON_DOWN : undefined,
                intent: this.intent,
                rounded: this.rounded,
                outlined: this.outlined,
                size: this.size,
                style: 'margin-bottom: 10px'
            }),
            (0, mithril_1.default)(_1.Button, {
                align: this.align,
                active: this.active,
                basic: this.basic,
                compact: this.compact,
                disabled: this.disabled,
                fluid: this.fluid,
                label: this.label && 'Anchor Button',
                sublabel: this.sublabel && 'Sublabel: ',
                loading: this.loading,
                iconLeft: this.iconLeft ? _1.Icons.LINK : undefined,
                iconRight: this.iconRight ? _1.Icons.CHEVRON_RIGHT : undefined,
                intent: this.intent,
                rounded: this.rounded,
                outlined: this.outlined,
                size: this.size,
                href: 'https://google.com',
                target: '_blank'
            })
        ]);
    };
    ButtonExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)('h5', 'Intent'),
            (0, mithril_1.default)(examples_1.IntentSelect, { onSelect: function (intent) { return _this.intent = intent; } }),
            (0, mithril_1.default)('h5', 'Align'),
            (0, mithril_1.default)(_1.Select, {
                fluid: true,
                defaultValue: 'center',
                options: Object.keys(_1.Align).map(function (key) { return _1.Align[key]; }),
                onchange: function (e) { return _this.align = e.target.value; },
                size: 'xs'
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.active,
                label: 'Active',
                onchange: function () { return _this.active = !_this.active; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.disabled,
                label: 'Disabled',
                onchange: function () { return _this.disabled = !_this.disabled; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.loading,
                label: 'Loading',
                onchange: function () { return _this.loading = !_this.loading; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.label,
                label: 'Label',
                onchange: function () { return _this.label = !_this.label; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.sublabel,
                label: 'Sublabel',
                onchange: function () { return _this.sublabel = !_this.sublabel; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.iconLeft,
                label: 'Icon left',
                onchange: function () { return _this.iconLeft = !_this.iconLeft; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.iconRight,
                label: 'Icon right',
                onchange: function () { return _this.iconRight = !_this.iconRight; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.basic,
                label: 'Basic',
                onchange: function () {
                    _this.basic = !_this.basic;
                    _this.outlined = false;
                }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.outlined,
                label: 'Outlined',
                onchange: function () {
                    _this.outlined = !_this.outlined;
                    _this.basic = false;
                }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.rounded,
                label: 'Rounded',
                onchange: function () { return _this.rounded = !_this.rounded; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.fluid,
                label: 'Fluid',
                onchange: function () { return _this.fluid = !_this.fluid; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.compact,
                label: 'Compact',
                onchange: function () { return _this.compact = !_this.compact; }
            })
        ];
    };
    return ButtonExample;
}());
exports.ButtonExample = ButtonExample;
